const currentEnvironment = process.env.REACT_APP_ENV || "stage";

const env = {
	development: {
		rest: process.env.REACT_APP_API_URL || "http://localhost:5001/api",
		plaid: "https://sandbox.plaid.com/",
		clientPortal: process.env.REACT_APP_CLIENT_PORTAL_URL || "http://localhost:3001/",
	},
	stage: {
		rest: "https://stage-api.getdocify.com/api",
		plaid: "https://sandbox.plaid.com/",
		clientPortal: "https://stage-app.srjca.com/",
	},
	production: {
		rest: "https://api.getdocify.com/api",
		plaid: "https://production.plaid.com/",
		clientPortal: "https://app.srjca.com/",
	},
};

const ConfigurationService = {
	/**
	 * Returns the endpoints for the current environment. The environment defaults to stage, and the
	 * development endpoints default to the standard local ports, so a build with no environment
	 * variables set behaves exactly as it did before. REACT_APP_ENV, REACT_APP_API_URL and
	 * REACT_APP_CLIENT_PORTAL_URL override them, which is how each git worktree points at its own
	 * locally running API without editing this file.
	 *
	 * @return {Object}
	 */
	resolveApi: () => {
		return env[currentEnvironment];
	},
};

export default ConfigurationService;
